import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

export default VisuallyHidden.Root;
